module.exports = __webpack_public_path__ + "img/login_logo.72fc9758.png";